import { AuthApiService } from '@revenuewell/logic-http';
import { NavigationService } from '@revenuewell/logic-navigation';
import { OidcService } from '@revenuewell/logic-oidc';
import { PatientFeedback, Review, Survey } from './patient-feedback-service-types';

export default class PatientFeedbackService extends AuthApiService {
  private static instance: PatientFeedbackService;

  private config: any;

  constructor(config: any, oidcService: OidcService) {
    super(oidcService, new NavigationService());
    this.config = config;
  }

  public static getInstance(config: any, oidcService: OidcService) {
    if (!PatientFeedbackService.instance)
      PatientFeedbackService.instance = new PatientFeedbackService(config, oidcService);

    return PatientFeedbackService.instance;
  }

  getReview = async (locationId: number, reviewId: number) => {
    const url = `${await this.config.patientFeedback.apiUrl}/location/${locationId}/reviews/${reviewId}`;
    const response = await this.authFetch(url);
    return (await response.json()) as Review;
  };

  getReviewById = async (locationId: number, patientId: number, reviewId: number) => {
    const url = `${await this.config.patientFeedback
      .apiUrl}/location/${locationId}/patient/${patientId}/reviews/${reviewId}`;

    const response = await this.authFetch(url);

    return (await response.json()) as Review;
  };

  getSurveyById = async (locationId: number, patientId: number, reviewId: number) => {
    const url = `${await this.config.patientFeedback
      .apiUrl}/location/${locationId}/patient/${patientId}/surveys/${reviewId}`;

    const response = await this.authFetch(url);

    return (await response.json()) as Survey;
  };

  getPatientFeedback = async (patientId: number, locationId: number) => {
    const url = `${await this.config.patientFeedback.apiUrl}/location/${locationId}/patient-feedback/${patientId}`;
    const response = await this.authFetch(url);

    return (await response.json()) as PatientFeedback[];
  };

  requestReview = async (locationId: number, patientId: number) => {
    const url = `${await this.config.patientFeedback
      .apiUrl}/location/${locationId}/patient/${patientId}/reviews/request`;

    await this.authFetch(url, {
      method: 'POST'
    });
  };

  requestSurvey = async (locationId: number, patientId: number) => {
    const url = `${await this.config.patientFeedback
      .apiUrl}/location/${locationId}/patient/${patientId}/surveys/request`;

    await this.authFetch(url, {
      method: 'POST'
    });
  };

  postReply = async (locationId: number, patientId: number, reviewId: number, replyText: string) => {
    const url = `${await this.config.patientFeedback
      .apiUrl}/location/${locationId}/patient/${patientId}/reviews/${reviewId}/reply`;
    await this.authFetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(replyText)
    });
  };

  deleteReplyToReview = async (locationId: number, patientId: number, reviewId: number) => {
    const url = `${await this.config.patientFeedback
      .apiUrl}/location/${locationId}/patient/${patientId}/reviews/${reviewId}/reply`;
    await this.authFetch(url, {
      method: 'DELETE'
    });
  };

  setReviewAsFeatured = async (locationId: number, reviewId: number, isFeatured: boolean) => {
    const url = `${await this.config.patientFeedback.apiUrl}/location/${locationId}/reviews/${reviewId}/setFeatured`;
    await this.authFetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ isFeatured })
    });
  };

  getUnreadReviewsCount = async (locationId: number) => {
    const url = `${await this.config.patientFeedback.apiUrl}/location/${locationId}/reviews/unread-count`;
    const response = await this.authFetch(url);

    const data = await response.json();
    return data.unreadReviewsCount || 0;
  }
}
